/* eslint react/no-danger: "off" */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { TWITTER_BASE_URL } from 'modules/Common/consts';

import './TwitterShareButton.scss';

export default class TwitterShareButton extends Component {
  static contextTypes = {
    metrics: PropTypes.object
  };

  static propTypes = {
    dcmp: PropTypes.string,
    page: PropTypes.string,
    title: PropTypes.string
  };

  getHref = () => {
    const {dcmp, page, title} = this.props;
    let href = page;

    if (dcmp) {
      href = `${page}?dcmp=sl_social_twitter_${dcmp}`;
    }

    const url = encodeURIComponent(href);
    const originalReferer = encodeURIComponent(page);
    const encTitle = encodeURIComponent(title + ":");

    return `${TWITTER_BASE_URL}?url=${url}&original_referer=${originalReferer}&text=${encTitle}`;
  };

  handleClick = () => {
    if (this.context.metrics) {
      this.context.metrics.track("linkClick", {link: "[Article Share] Twitter"});
    }
  };

  render(){
    return <a href={this.getHref()} onClick={this.handleClick} target="_blank" className={"social-share-button-twitter"}>
      <div className="social-share-button-twitter-image">
        <div className="twitter-icon" title="Tweet">
          <img src={"/img/icons/twitter.svg"}/>
        </div>
      </div>
      <div className="social-share-button-twitter-text">Tweet</div>
    </a>;
  }
}




// WEBPACK FOOTER //
// ./modules/Common/components/TwitterShareButton.js